import StyleChanger from './MapStyleChanger.vue';

export default {
    data: () => ({
        // map layers to preserve between style changes
        // be sure to add/remove from this array as layers are added/removed from the map
        mapLayers: [],

        // map style options for the style changer control
        mapStyles: [
            {
                label: 'Base Map',
                styleUrl: 'mapbox://styles/mapbox/streets-v11',
            },
            {
                label: 'Satellite',
                styleUrl: 'mapbox://styles/mapbox/satellite-v9',
            },
        ],

        // current map style
        mapStyle: null,
    }),

    components: {
        StyleChanger,
    },

    created() {
        // if no initial map style is explicitly set, use the first one in this.mapStyles
        if (this.mapStyle === null) {
            [this.mapStyle] = this.mapStyles;
        }
    },

    methods: {
        /**
         * Callback for addStyleControl. It runs after the map layers are re-added. It receives the map as a parameter,
         * though it can be ignored in the method definition.
         */
        onMapStyleChange() {
            // override locally to do extra tasks after the map layers in this.layers get re-added
        },

        /**
         * Changes the map style to the given style. Sets a callback that will run after the style has been change.
         * This callback restores any layers in `this.mapLayers` and then calls `onMapStyleChange`.
         *
         * @param {object} newStyle - map style object with label and url
         */
        changeMapStyle(newStyle) {
            this.mapStyle = newStyle;
            this.map.setStyle(newStyle.styleUrl);

            // once the new map style is loaded, re-add map layers
            this.map.once('styledata', () => {
                this.mapLayers.forEach((layer) => {
                    this.map.addLayer(layer);
                });

                // fire callback method after layers are re-added
                this.onMapStyleChange(this.map);
            });
        },
    },
};
